export default __webpack_public_path__ + "static/media/moonstar8.37b4acda.jpg";